/**
 * 注意！！
 * 不能直接将 import.meta.env 进行解构。
 * 如果解构会导致所有环境变量暴露在生产环境。
 */

// 是否是测试环境
export const __DEV__ = import.meta.env.VITE__DEV__;

// 是否是本地环境
export const __LOCAL__ = import.meta.env.VITE__LOCAL__;

// 项目名称
export const __PROJECT_NAME__ = import.meta.env.VITE_PROJECT_NAME;

// 项目默认渠道号
export const __DEFAULT_CHANNEL__ = import.meta.env.VITE_APP_DEFAULT_CHANNEL;

export const __DEFAULT_PLATFORM__ = import.meta.env.VITE_APP_PLATFORM;

export const __BASE_URL__ = import.meta.env.BASE_URL;

export const __DESIGN_WIDTH__ = import.meta.env.VITE__DESIGN_WIDTH__;
